var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('textloader-component',{attrs:{"textKey":"NyKurschemaRubrik"}})],1),_c('paragraph-component',[_c('textloader-component',{attrs:{"textKey":"NyKurschemaBrödtext"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }